module.exports = __webpack_public_path__ + "img/poster-corner-flag.48ecc607.png";